import { set } from "dot-prop-immutable";

const ABLAUF_SNAPSHOT = "ABLAUF_SNAPSHOT";
const ABLAUF_CHANGED = "ABLAUF_CHANGED";
const ABLAUF_RESET = "ABLAUF_RESET";

export const ablaufSnapshotAction = snapshot =>({
	type: ABLAUF_SNAPSHOT,
	snapshot: snapshot /* Object */
});

export const ablaufChangedAction = change => ({
	type: ABLAUF_CHANGED,
	change: change	/* [{ path: string, value: Object }, { path: string, value: Object }, ...] */
});

export const ablaufResetAction = () => ({
	type: ABLAUF_RESET
});

/* Es muss einen initialen Stand geben. Wenn es gerade keine Verbindung
 * zwischen unserem socket_io Server und dem Ablauf gibt, dann kann
 * kein Snapshot geliefert werden, und die Oberfläche muss irgendwie
 * damit zurecht kommen.
 */
const initial_ablauf = {
	master: {
		sd_status: 0
	},
	compressors: [],
	maintenance: [],
	errors: [],
	statistics: {
		think_green: {}
	},
	system: {
		tz: "UTC"
	}
};

export const ablaufReducer = (state = initial_ablauf, action) => {
	switch (action.type) {
	case ABLAUF_SNAPSHOT: {
		/* Hier muss gar nicht lange herum gemacht werden: einfach das ganze
		 * Modell ersetzen.
		 */
		return action.snapshot;
	}
	case ABLAUF_CHANGED: {
		/* Ein oder mehrere Werte haben sich geändert. */
		let new_state = action.change.reduce((accu, curr) => {
			return set(accu, curr.path, curr.value);
		}, state);
		return new_state;
	}
	case ABLAUF_RESET: {
		return initial_ablauf;
	}
	default:
		break;
	}
	return state;
};

export const formatAuslastung = value => {
	return value === 0 ? "0"
		: value ? Math.round(value * 100).toString()
			: "---";	/* null oder undefined */
};
